import Model from '@/models/Model.js';

export default class EnrollmentGroupColor extends Model {
    static entity = 'enrollment_group_colors';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            background_color: this.attr(null),
            text_color: this.attr(null),

            ...super.fields(),
        };
    }

    get style() {
        return {
            'background-color': `#${this.background_color} !important`,
            color: `#${this.text_color} !important`,
            'z-index': 99,
        };
    }
}
